import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { MarcaDoBanco } from '../../components/MarcaDoBanco';
import { Valor } from '../../components/Valor';
import { api } from '../../lib/api';

/**
 * Onde o dinheiro esta, banco por banco.
 *
 * "Disponivel" soma tudo, e somar e o certo: sao todas contas da mesma
 * pessoa, um patrimonio so. Mas quem vai pagar uma conta hoje precisa da
 * outra resposta — em QUAL banco o dinheiro esta —, porque e de um banco
 * especifico que o boleto sai.
 *
 * A soma e do servidor, em centavos inteiros, como todo dinheiro deste
 * sistema. A tela so escolhe a ordem das coisas na linha.
 */
export function SaldoPorBanco() {
  const bancos = useQuery({ queryKey: ['bancos'], queryFn: () => api.bancos() });

  const dados = bancos.data;
  if (!dados || dados.bancos.length === 0) return null;

  return (
    <section className="card">
      <h2 className="card-title">Onde esta o dinheiro</h2>
      <p className="card-hint">
        O saldo de cada banco. A fatura do cartao aparece a parte: ela ainda nao saiu da conta.
      </p>

      <ul className="bancos">
        {dados.bancos.map((banco) => (
          <li key={banco.nome} className="banco">
            <MarcaDoBanco nome={banco.nome} />

            <div className="banco-corpo">
              <div className="between">
                <span className="banco-nome">{banco.nome}</span>
                <Valor cents={banco.saldoCents} className="banco-saldo" />
              </div>

              <ul className="banco-contas">
                {banco.contas.map((conta) => (
                  <li key={conta.id}>
                    <Link to={`/lancamentos?accountId=${conta.id}`}>{conta.name}</Link>
                    <Valor cents={conta.currentBalanceCents} />
                  </li>
                ))}
              </ul>

              {banco.faturaCents !== '0' && (
                <span className="banco-fatura">
                  Fatura em aberto <Valor cents={banco.faturaCents} saida />
                </span>
              )}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
